@if (medicalData) {
  <div class="health-folder-container">
    <div class="header-container">
      <app-info-box
        [iconOptions]="{ type: 'folder-open', theme: 'outline' }"
        [cssProperties]="{ font_size_title: 30 }"
        title="{{ 'healthFolder.title' | translate }}"
        description="{{ 'healthFolder.subtitle' | translate }}"
      ></app-info-box>
      <ds-button
        [text]="'healthFolder.report' | translate"
        [styleType]="'empty-main'"
        [iconRight]="'/public/assets/images/icon-right-blue.svg'"
        [iconLeft]="'/public/assets/images/mail-icon.svg'"
        (click)="openReportPage()"
      ></ds-button>
      <ds-button
        [text]="'healthFolder.passport' | translate"
        [styleType]="'empty-main'"
        [iconLeft]="'/public/assets/images/file-icon.svg'"
        (click)="openPassportHealth()"
      ></ds-button>
    </div>
    <div class="content-container">
      <div class="menu-container">
        <app-navigation-menu [links]="['medical-data', 'medical-history', 'misuration']" [translationEntryPoint]="'healthFolder.'"></app-navigation-menu>
        <div class="tipside">
          <app-tipside [styleType]="'compact'"></app-tipside>
        </div>
      </div>

      <router-outlet></router-outlet>
    </div>
  </div>
}
